import CloverCard from '../clover/clover-card/clover-card.component';
import StripeCard from '../incentivio/stripe-card/stripe-card.component';
import { PaymentGatewayType } from '../payment.constants';
import { usePaymentGatewayMatches } from '../payment.new.hooks';
import SpreedlyCheckoutSdkCardContainer from '../spreedly-checkout-sdk/spreedly-card/spreedly-checkout-sdk-card-container.component';
import SquareCard from '../square/square-card/square-card.component';

const CardPayment = ({ ...rest }) => {
  const matchesPaymentGateway = usePaymentGatewayMatches();

  if (matchesPaymentGateway([PaymentGatewayType.SPREEDLY])) {
    return <SpreedlyCheckoutSdkCardContainer {...rest} button />;
  }

  if (matchesPaymentGateway([PaymentGatewayType.SQUARE]))
    return <SquareCard {...rest} />;

  if (matchesPaymentGateway([PaymentGatewayType.CLOVER]))
    return <CloverCard {...rest} />;

  return <StripeCard {...rest} />;
};

export default CardPayment;
